import { render, staticRenderFns } from "./ThinPic.vue?vue&type=template&id=e5847e9e&scoped=true&"
import script from "./ThinPic.vue?vue&type=script&lang=ts&"
export * from "./ThinPic.vue?vue&type=script&lang=ts&"
import style0 from "./ThinPic.vue?vue&type=style&index=0&id=e5847e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5847e9e",
  null
  
)

export default component.exports